import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Call Records'
      breadcrumbs={[
        {
          label: 'History',
        },
        {
          label: 'Call Records',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/history/call-records',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
